export const mockContactMethods = [
  {
    id: 1,
    type: "email",
    value: "sample@email.com",
    description: "Sample Email",
    variables: [],
  },
  {
    id: 2,
    type: "sms",
    value: "12223334444",
    description: "Sample Text", // Optional
    variables: [
      { id: 1, type: "DND_StartTime", value: "16:00:00" },
      { id: 2, type: "DND_EndTime", value: "10:00:00" },
    ],
  },
];

export function getContactMethods() {
  console.log("%c-- MOCK: getContactMethods", "color: green; font-weight: bold;");
  return [200, mockContactMethods];
}

export function createContactMethod(config: any) {
  const contactMethod = JSON.parse(config.data);

  mockContactMethods.push({
    id: mockContactMethods.length + 1,
    type: contactMethod.contactType,
    value: contactMethod.contactString,
    description: contactMethod.description,
    variables: contactMethod.variables,
  });

  return [200, { status: "mock" }];
}
